import * as yup from 'yup';

export const schema = yup.object({
  address: yup.object().shape({
    region: yup.object().required('Region is required.').nullable(true),
    province: yup.object().required('Province is required.').nullable(true),
    municipality: yup
      .object()
      .required('Municipality is required.')
      .nullable(true),
    barangay: yup.object().required('Barangay is required.').nullable(true),
    zip_code: yup
      .string()
      .required('Zip code is required.')
      .matches(/^(\d{4})$/, 'Invalid format'),
    full_address: yup
      .string()
      .required('House No./Unit Number/Street is required.'),
  }),
});

export const INIT_FORM = {
  address: {
    region: {
      value: '130000000',
      label: 'NATIONAL CAPITAL REGION (NCR)',
    },
    province: {
      value: '133900000',
      label: 'NCR, CITY OF MANILA, FIRST DISTRICT',
    },
    municipality: '',
    barangay: '',
    zip_code: '',
    full_address: '',
  },
};
